// True when any route param is a placeholder produced by interpolating a cleared
// value into a path (e.g. `/workflow/${undefined}/${undefined}` -> the literal
// strings "undefined"/"null"). Such routes render a dead "Not found" page and can
// trap a user post-login, so the navigation guard bounces them to the dashboard.
export const hasUnusableRouteParam = (params = {}) =>
  Object.values(params).some((v) => v === 'undefined' || v === 'null')
